const KEY = 'rootCrash.healedAt';
/** Сколько ждём между самолечениями: чтобы сбой не гонял страницу по кругу. */
const AGAIN_MS = 60_000;

/** Первый сбой за минуту лечим сами: стираем копию данных на устройстве (самая частая причина) и открываем заново. */
export function shouldSelfHeal(now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? '0');
    if (now - last < AGAIN_MS) return false;
    sessionStorage.setItem(KEY, String(now));
    return true;
  } catch {
    return false;
  }
}
